import { MultiSelect } from "@/components/ui/multi-select";
import type { UseTeamFilterResult } from "@/hooks/useTeamFilter";

interface TeamFilterSelectProps {
  teamFilter: Pick<UseTeamFilterResult, "groupedTeamOptions" | "selectedTeamIds" | "setSelectedTeamIds">;
}

/**
 * Multi-select Team filter, grouped by Head of Sales. Ticking/unticking teams filters Recent
 * Activity / All Requests by matching each row's `agentName` to a team (see useTeamFilter).
 * Clicking a HoS group heading selects/deselects every team under that HoS at once.
 * An empty selection means "no filter" — untick everything to see all teams again.
 */
export function TeamFilterSelect({ teamFilter }: TeamFilterSelectProps) {
  const { groupedTeamOptions, selectedTeamIds, setSelectedTeamIds } = teamFilter;

  return (
    <MultiSelect
      options={groupedTeamOptions}
      defaultValue={selectedTeamIds}
      onValueChange={setSelectedTeamIds}
      placeholder="All Teams"
      maxCount={0}
      showBadges={false}
      groupHeadingsSelectable
      groupItemNoun="teams"
      minWidth="180px"
      maxWidth="180px"
      className="h-9 min-h-9 shrink-0 border-border bg-card px-3 py-1.5 text-sm shadow-none"
      popoverClassName="w-72"
    />
  );
}
